import React, {Suspense, useEffect, useState} from "react";
import Afterloginheader from "../components/MainHeader/Afterloginheader";
import Background from "../assets/images/Hero.jpg";
import Doctor from "../assets/images/Doctor.png";
import Community from "../assets/images/community.svg";
import Chat from "../assets/images/chat.svg";
import Calendar from "../assets/images/calendar.svg";
// import TextTypingAnimation from "../components/TextTypingAnimation";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AppImg from "../assets/images/app.png";
import Play from "../assets/images/play.svg";
import Appstore from "../assets/images/AppStore.svg";

// import TestimonialsCarousel from "../components/TestimonialsCarousel";
import Footer from "../components/Footer/Footer";

// import Searchfilter from "../components/Searchfilter";
import {useUserContext} from "../context/UserContext";
import Header from "../components/MainHeader/Mainheader";
import {useNavigate} from "react-router";
import axios from "axios";
import {Helmet} from "react-helmet-async";

// const Searchfilter = React.lazy(() => delayForDemo(import("../components/Searchfilter")));
const Searchfilter = React.lazy(() => import("../components/Searchfilter"));
const TextTypingAnimation = React.lazy(() => import("../components/TextTypingAnimation"));
const TestimonialsCarousel = React.lazy(() => import("../components/TestimonialsCarousel"));

function delayForDemo(promise) {
  return new Promise(resolve => {
    setTimeout(resolve, 1000);
  }).then(() => promise);
}

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Home = () => {
  const {userData, setSearchValuesContext} = useUserContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (userData) {
      if (userData?.users?.type === "Doctor") {
        navigate("/doctor/dashboard");
      } else if (userData?.users?.type === "Nurse") {
        navigate("/nurse/appointments");
      }
    }
    sessionStorage.removeItem("doctolikHomeSearchValue");
    setSearchValuesContext(null);
  }, []);

  return (
    <div className="HomeBody">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Doctolik`}</title>
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
        <meta name="description" content="This is Doctolik Home page" />
      </Helmet>
      {userData ? <Afterloginheader data-testid="after-login-header" /> : <Header data-testid="header" />}
      <div className="hero" style={{backgroundImage: "url(" + Background + ")"}}>
        <div className="HeroContainer">
          <div className="HeroLft">
            <h3>
              Find an appointment with <br />{" "}
              <Suspense fallback={""}>
                <TextTypingAnimation />
              </Suspense>
            </h3>
            <div className="HeroFrm">
              <Suspense fallback={""}>
                <Searchfilter />
              </Suspense>
            </div>
          </div>
          <div className="HeroRgt">
            <img src={Doctor} className="MainLogo" alt="logo" />
          </div>
        </div>
      </div>
      <div className="Features">
        <div className="FeaturesContainer">
          <div className="Sectiontitle">
            <h5>Features</h5>
            <h6>Doctolik: Serving your health needs</h6>
          </div>
          <div className="FeaturesList">
            <div className="FeaturesBox">
              <span className="FeaturesIcon">
                <img src={Community} className="FeaturesIcon" alt="ficon" />
              </span>
              <p>Access a wide community of practitioners simple and quickly.</p>
            </div>
            <div className="FeaturesBox">
              <span className="FeaturesIcon">
                <img src={Calendar} className="FeaturesIcon" alt="ficon" />
              </span>
              <p>Manage your appointments and reminders, view your history, and much more!</p>
            </div>
            <div className="FeaturesBox">
              <span className="FeaturesIcon">
                <img src={Chat} className="FeaturesIcon" alt="ficon" />
              </span>
              <p>Consult your practitioners via video or chat, wherever you are.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="Testimonials">
        <div className="TestimonialsContainer">
          <div className="Sectiontitle">
            <h5>Testimonials</h5>
            <h6>What our users are saying</h6>
          </div>
          <Suspense fallback={""}>
            <TestimonialsCarousel />
          </Suspense>
        </div>
      </div>

      <div className="AppDiv">
        <div className="AppContainer">
          <div className="AppBox">
            <div className="AppBoxLft">
              <img src={AppImg} className="AppBig" alt="logoIcon" />
            </div>

            <div className="AppBoxRgt">
              <h5>Download the Doctolik app</h5>
              <p>Access video consultation established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
              <h4>Get the link to download the app</h4>

              <div className="appgrp">
                <img src={Appstore} className="applogo" alt="logoIcon" />
                <img src={Play} className="applogo" alt="logoIcon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
